import React from "react";

import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";

const ExtendedThemeSettings = ({ onChange, styleAttributes }) => {
  const EXCLUDED_SETTINGS = [
    "base-bg",
    "base-bg-image",
    "base-bg-repeat",
    "base-bg-position",
    "base-font-color",
    "base-font-family",
    "body-font-size",
    "h1-font-color",
    "h1-font-family",
    "h1-font-size",
    "h2-font-color",
    "h2-font-family",
    "h2-font-size",
    "h3-font-color",
    "h3-font-family",
    "h3-font-size",
    'wrapper-padding-top',
    'column-cell-padding-bottom'
  ];
  const handleChange = (field) => {
    return (value) => {
      onChange(field, value);
    }
  };

  const extendedSettings = Object.keys(styleAttributes).filter(x => !EXCLUDED_SETTINGS.includes(x))

  const renderSetting = (key) => {
    return <SingleStringSetting
      value={styleAttributes[key]}
      onChange={handleChange(key)}
      key={key}
      label={key}
    />
  };
  return (
    <>
      {extendedSettings.map(renderSetting)}
    </>
  );

};

export default ExtendedThemeSettings;
